export default __webpack_public_path__ + "static/media/menu_card_appointment.3d89bacf.svg";